import { RichBlockRenderer } from "@repo/components";
export default function RichText({
  data
}) {
  return <section data-sentry-component="RichText" data-sentry-source-file="RichText.jsx">
      <RichBlockRenderer content={data?.content || data} data-sentry-element="RichBlockRenderer" data-sentry-source-file="RichText.jsx" />
    </section>;
}